import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocaleService } from './locale.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [LocaleService],
})
export class LocaleModule {}
